export default class Currency {

    constructor(jsonResponse) {

        this.brandId = jsonResponse["brand-id"];

        this.countryId = jsonResponse["country-id"];
        this.countryCode = jsonResponse["country-code"];
        this.countryName = jsonResponse["country-name"];

        this.payoutMethodId = jsonResponse["payout-method-id"];
        this.payoutMethod = jsonResponse["payout-method"];

        this.payoutPartnerId = jsonResponse["payout-partner-id"];
        this.payoutPartnerName = jsonResponse["payout-partner-name"];
        this.payoutPartnerBrandReferenceId = jsonResponse["payout-partner-brand-reference-id"];

        this.id = jsonResponse["id"];
        this.code = jsonResponse["code"];
        this.name = this.code;

        this.active = jsonResponse["active"];
        this.available = jsonResponse["available"];

    }
}
